"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CodeEdit;

var _element = require("@wordpress/element");

var _i18n = require("@wordpress/i18n");

var _blockEditor = require("@wordpress/block-editor");

/**
 * WordPress dependencies
 */
function CodeEdit(_ref) {
  let {
    attributes,
    setAttributes,
    onRemove
  } = _ref;
  const blockProps = (0, _blockEditor.useBlockProps)();
  return (0, _element.createElement)("pre", blockProps, (0, _element.createElement)(_blockEditor.RichText, {
    tagName: "code",
    value: attributes.content,
    onChange: content => setAttributes({
      content
    }),
    onRemove: onRemove,
    placeholder: (0, _i18n.__)('Write code…'),
    "aria-label": (0, _i18n.__)('Code'),
    preserveWhiteSpace: true,
    __unstablePastePlainText: true
  }));
}
//# sourceMappingURL=edit.js.map